




import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import CampaignStatus from '@/models/Campaigns/CampaignStatus';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';

@Component({
  name: 'CampaignStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status: CampaignStatus;

	@Prop({required: true})
	location: StatusDisplayLocation;

	get textColor() {
		let color = "black--text";
		switch (this.status) {
			case CampaignStatus.Draft:
			case CampaignStatus.Scheduled:
			case CampaignStatus.Processing:
				color = "orange--text"
				break;
			case CampaignStatus.Paused:
				color = "red--text"
				break;
			case CampaignStatus.Active:
				color = "green--text"	
				break;	
			default:
				color = "black-text"
				break;
		}
		return color;
	}

	get text() {
		let text = "";
		switch (this.status) {
			case CampaignStatus.Draft:
				text = "DRAFT";
				break;
			case CampaignStatus.Processing:
				text = "PROCESSING"
				break;
			case CampaignStatus.Scheduled:
				text = "SCHEDULED"
				break;
			case CampaignStatus.Paused:
				text = "PAUSED"
				break;
			case CampaignStatus.Active:
				text = "ACTIVE"
				break;
			case CampaignStatus.Closed:
				text = "CLOSED"
				break;
			default:
				text = "UNKNOWN STATUS"
				break;
		}
		return text;
	}
	
	get classy() {
		const classes: string[] = [this.textColor]
		switch (this.location) {
			case StatusDisplayLocation.Title:
				classes.push("overline");
				classes.push("ma-2");
				break;
			case StatusDisplayLocation.Grid:
				classes.push("overline");
				break;
			case StatusDisplayLocation.SubTitle:
			default:
				classes.push("overline");
				classes.push("ma-2");
				break;
		}
		return classes;
	}
}
